export default {
  title: "Mes tickets",
  refresh: "Actualiser",
  create: "Créer",
  id: "ID du ticket",
  type: "Type",
  status: "Statut",
  createdAt: "Créé le",
  actions: "Actions",
  detailTitle: "Détails du ticket",
  email: "Email",
  description: "Description",
  response: "Réponse",
  noResponse: "Aucune réponse pour le moment",
  statusPending: "En attente",
  statusResolved: "Résolu",
  statusClosed: "Fermé",
};
